
jQuery( async ( $ ) => {

	// Displays the suggestedPaymentInterval in the box on page load
	// Calculates the number of pledge payments on page load 
	if ( 0 < $( '.pledge-donations' ).length ) {
		const suggestedPaymentFrequency = $( 'input:radio[name=\'paymentInterval\']:checked' ).val();
		$( '.pledge-donation-freq-box-display' ).text( suggestedPaymentFrequency );
		calculatePledgeDonations();
	}

	// Displays the suggestedPaymentInterval in the box on page load if there is one
	if ( 0 < $( '.regular-donations' ).length ) {
		const suggestedPaymentFrequency = $( 'input:radio[name=\'paymentInterval\']:checked' ).val();
		$( '.reg-donation-freq-box-display' ).text( suggestedPaymentFrequency );
	}

	$( '.donation-frequencys-ul li input' ).on( 'click', function(){
		$( '.reg-donation-freq-box-display' ).text( this.value );
	} );

	// Makes the first donation type of a donation fund open by default on page load
	
	// PS have asked for this to be removed, keeping the code as they could ask for it back. 

	// $( '.donation-funds-container-new .donation-fund-wrapper' ).each( function() {
	// 	$( this ).find( '.donation-items-inner-wrapper' ).first().css( 'display', 'block' );
	// 	return;
	// } );


	const productTranslations = await $.get( red61.ajax_url, { action: 'get_translations', component: 'productPage' } );
	const {translations} = productTranslations;

	window.translations = {
		...productTranslations.translations
	};

	$( '.donations .donation-item input' ).keyup( function() {
		updateBtnState( this );
	} );

	$( '.donations .donation-item input' ).change( function() {
		updateBtnState( this );
	} );

	// Donate to fund Page

	$( '.donation-btn-type' ).click( function () {
		if ( $( this ).closest( '.donation-items' ).find( '.donation-items-inner-wrapper' ).is( ':hidden' ) ) {
			$( this ).closest( '.donation-items' ).find( '.donation-items-inner-wrapper' ).slideDown( 'slow' );
		} else {
			$( this ).closest( '.donation-items' ).find( '.donation-items-inner-wrapper' ).slideUp( 'slow' );
		}
	} );

	// Getting the donation funds page to show all the totals of funds  

	const donationFundIdsCssClass = [];
	
	$( '.donation-funds-container-new .donation-fund-wrapper' ).each( function() {
		const donationFundRefCssClass = this.dataset.donationFundId.replace( ':', '-' );
		donationFundIdsCssClass.push( donationFundRefCssClass );
	} ).get();

	donationFundIdsCssClass.forEach( ( donationFundIdCssClass ) => {
		let percentageValue = $( `.percentage-of-donation-fund-achieved-${donationFundIdCssClass}` ).val();
		if ( 100 < percentageValue ) {
			percentageValue = 100;
		}
		progress( percentageValue, $( `#progress-bar-donation-fund-${donationFundIdCssClass}` ) );
	} );

	// Getting the pledge page to show the total of a certain fund

	if ( 0 < $( '.percentage-of-donation-fund-achieved-on-donation-type-page' ).length ){
		let percentageValue = $( '.percentage-of-donation-fund-achieved-on-donation-type-page' ).val();
		if ( 100 < percentageValue ) {
			percentageValue = 100;
		}
		progress( percentageValue, $( '#progress-bar-on-donation-type-page' ) );
	}

	function progress( percent, $element ) {
		const progressBarWidth = percent * $element.width() / 100;
		$element.find( 'div' ).animate( { width: progressBarWidth }, 500 );
	}	

	// Regular Donation Page

	$( '.donation-frequency-btn' ).click( function() {
		$( '.recurring-donation-freq-box-display' ).text( this.textContent ) ;
	} );
	
	$( '.recurring-donation-input-amount' ).on( 'input', function(){
		const donationAmount = $( '.recurring-donation-input-amount' ).val();
		if( 0 < parseInt ( donationAmount ) ) {
			$( '.reg-donation-amount-box-display span' ).text( donationAmount );
		} else {
			$( '.reg-donation-amount-box-display span' ).text( 0 );
		}
	} );
	
	// Pledges
	function calculatePledgeDonations() {
		// Updates the UI in the Donations box
		const donationAmount = parseInt ( $( '.pledge-donation-input-amount' ).val() );
		const pledgeFrequencyText = $( 'input:radio[name=\'paymentInterval\']:checked' ).val();
		const paymentIntervalObject = {
			'MONTHLY': 1,
			'QUARTERLY': 3,
			'ANNUALLY': 12
		};
		const pledgeFrequency = paymentIntervalObject[pledgeFrequencyText];
		const pledgeDurationYearsInMonths = $( '.pledge-donation-length-years' ).val() * 12;
		let pledgeDurationInMonths = $( '.pledge-donation-length-months' ).val();

		// Rounds up the number of months to the nearest multiple of 3 if paymentFrequency is quarterly
		if ( 'QUARTERLY' == pledgeFrequencyText ) {
			pledgeDurationInMonths = Math.round( pledgeDurationInMonths / 3 )*3;
			$( '.pledge-donation-length-months' ).val( pledgeDurationInMonths );
		} 
		const pledgeDuration =  parseInt ( pledgeDurationYearsInMonths ) + parseInt ( pledgeDurationInMonths );
		const donationAmountPerPledgePayment = donationAmount / pledgeDuration * pledgeFrequency;
		if ( 0 < donationAmountPerPledgePayment && 'Infinity' != donationAmountPerPledgePayment ) {
			$( '.pledge-donation-amount-box-display span' ).text( donationAmountPerPledgePayment.toFixed( 2 ) );
		} else if( donationAmount ) {
			// If not all the pledge fields are filled in then it displays the amount in the donation amount input field
			$( '.pledge-donation-amount-box-display span' ).text( donationAmount.toFixed( 2 ) );
		} else {
			$( '.pledge-donation-amount-box-display span' ).text( '0.00' );
		}

		calculateNoOfPledgePayments( pledgeDuration, pledgeFrequency );
	}

	function calculateNoOfPledgePayments( pledgeDuration, pledgeFrequency ){
		const totalNumberOfPledgePayments = pledgeDuration / pledgeFrequency;
		$( '.number-of-pledge-payments' ).attr( 'value', totalNumberOfPledgePayments );
	}


	$( '#pledge-donation-form input' ).on( 'input', function() {
		calculatePledgeDonations();
	} );

	$( '.pledge-donations .donation-frequency-btn' ).click( function() {
		$( '.pledge-donation-freq-box-display' ).text( this.textContent ) ;
	} );

	// End of Pledges

	$( '.donations .add-to-basket' ).click( async function( event ) {
		event.preventDefault();
		const donationFundRef = $( this ).closest( '.donation-item' ).find( 'input[name="donationFundRef"]' ).val();
		const donationFundRefCssClass = donationFundRef.replace( ':', '-' );
		const response = await addToBasket( $( this ) );
		updateBasketMessage( response.message, donationFundRefCssClass );

		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.donation-item' ).find( 'input[name="donationAmount"]' ).val( '' );
			$( this ).addClass( 'disabled-btn-state' );
		}
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
	} );

	$( '.donations .add-to-basket-one-off-donation' ).click( async function( event ) {
		event.preventDefault();
		const donationFundTypeRef = $( this ).closest( '.donation-item' ).find( 'input[name="donationFundTypeRef"]' ).val();
		const donationFundTypeRefCssClass = donationFundTypeRef.replace( ':', '-' );
		const response = await addToBasket( $( this ) );
		updateBasketMessage ( response.message, donationFundTypeRefCssClass );

		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.donation-item' ).find( 'input[name="donationAmount"]' ).val( '' );
			$( this ).addClass( 'disabled-btn-state' );
		}
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
	} );


	function updateBasketMessage( message, donationRef ) {
		const pageURL = `${window.location.href  }`;
		const pageURLwithPolyLang = pageURL.replace( 'donations', 'basket' );
		$( `.basket-message-${donationRef} div` ).text( message.text );
		if( 'alert-success' === message.className ){
			const goToCheckout = _.template(
				'<%- translations[ "GO TO CHECKOUT" ] || "GO TO CHECKOUT" %>'
			);
			$( `.basket-message-${donationRef}` ).append( `<a class="underline" href="${ pageURLwithPolyLang }">${ goToCheckout( translations ) }</a>` );
		}
		$( `.basket-message-${donationRef}` ).attr( 'class', `alert ${message.className} donations-basket-response-alert` );
	}
		
		
	async function addToBasket( $button ) {
		$( '.basket-message' ).addClass( 'd-none' );
		$button.addClass( 'disabled-btn-state' );

		const formData = new FormData();
		formData.append( 'action', 'add_donation_to_basket' );
		formData.append( 'donationAmount',
			$button.closest( '.donation-item' ).find( 'input[name="donationAmount"]' ).val(),
		);
		formData.append( 'donationFundRef',
			$button.closest( '.donation-item' ).find( 'input[name="donationFundRef"]' ).val(),
		);
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		$button.removeClass( 'disabled-btn-state' );
		return response;
	}

	function updateBtnState( input ) {
		if ( 0 < input.value ) {
			$( input )
				.closest( '.donation-item' )
				.find( '.btn-standard' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );
		}
		else {
			$( input )
				.closest( '.donation-item' )
				.find( '.btn-standard' )
				.addClass( 'disabled-btn-state' )
				.prop( 'disabled', true );
		}
	}

	// Terms and Conditions Check 

	// NB This is being used for both regular donations & pledges
	// Sigurd: Will require these 2 pages to be on different URLS so a display: none this is being avoided 
	$( '#termsCheckboxDonations' ).click( function() {
		if( $( '#termsCheckboxDonations' ).is( ':checked' ) ) {
			$( '.donate-btn' ).removeAttr( 'disabled' );
		} else {
			$( '.donate-btn' ).prop( 'disabled', true );
		}
	} );


} );
